import React from 'react';
import {toast} from 'react-toastify';

const UNDO_TOAST_ID = 'informes-undo';
const AUTO_CLOSE_MS = 8000;

function UndoToastContent({message, undoLabel, onUndo, closeToast}) {
    return (
        <div className="inf-toast">
            <span className="inf-toast-message">{message}</span>
            {onUndo && (
                <button type="button" className="inf-toast-undo" onClick={() => { onUndo(); if (closeToast) closeToast(); }}>
                    {undoLabel}
                </button>
            )}
        </div>
    );
}

/**
 * El toast con "Deshacer" del mockup (quitar un panel, quitar una métrica destacada).
 *
 * Un solo `toastId`: si ya hay uno activo se actualiza — react-toastify DESCARTA en silencio un
 * `toast()` con un id ya activo (gotcha documentado del repo). `updateId` va SIEMPRE, y cambia
 * con cada acción: sin él, quitar dos paneles seguidos dejaba el aviso del primero («"Métrica
 * destacada" quitado») mientras el botón deshacía el segundo, y el timer no se reiniciaba
 * (QA caso 09).
 */
export function showUndoToast(message, onUndo, undoLabel, actionId = null) {
    const render = ({closeToast}) => (
        <UndoToastContent message={message} undoLabel={undoLabel} onUndo={onUndo} closeToast={closeToast}/>
    );
    const options = {
        toastId: UNDO_TOAST_ID,
        updateId: actionId || String(Date.now()),
        autoClose: AUTO_CLOSE_MS,
        closeOnClick: false,
        pauseOnHover: true,
    };
    if (toast.isActive(UNDO_TOAST_ID)) {
        toast.update(UNDO_TOAST_ID, {...options, render});
    } else {
        toast(render, options);
    }
}
